import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { debounce } from 'lodash';

import GameModal from 'components/flink-play/GameModal/GameModal';
import { imagesURL } from 'config';
import { setFeedbackCoords } from 'actions/flinkPlayActions';

const MobileFindTheOneFeedback = ({
  feedback,
  audioSrc,
  onToggleAudio,
  onClose,
}) => {
  const translate = useSelector(
    ({ flinkPlay, status }) => flinkPlay.solutionTranslate || status.translate
  );
  const feedbackCoords = useSelector(
    ({ flinkPlay }) => flinkPlay.feedbackCoords
  );
  const audioState = useSelector(({ audio }) => audio);
  const dispatch = useDispatch();

  const debouncedDragHandler = React.useMemo(
    () => debounce((...args) => dispatch(setFeedbackCoords(...args)), 300),
    [dispatch]
  );

  if (!feedback || !feedback.text) return null;

  const audioIcon = `${imagesURL}/Images/Audio/${
    audioSrc && audioState.audioSrc === audioSrc && audioState.isPlaying
      ? 'audiostop'
      : 'audio_icon1'
  }.png`;

  return (
    <GameModal
      draggable
      draggableProps={{
        position: feedbackCoords,
        onDrag: debouncedDragHandler,
      }}
      title={translate(950, 'Feedback')}
      buttons={[
        {
          clickHandler: () => onToggleAudio && onToggleAudio(audioSrc),
          dontShow: !audioSrc,
          icon: audioIcon,
        },
        {
          clickHandler: onClose,
          icon: `${imagesURL}/Images/Help/Close50.png`,
        },
      ]}
    >
      <div style={{ fontSize: '2vmin' }}>{feedback.text}</div>
    </GameModal>
  );
};

export default MobileFindTheOneFeedback;
